import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './nospend.json';

const Nospend = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Financial English for budgeting, saving, and no-spend challenges. B2 level exercises including grammar, vocabulary, and discussion."
            level="B2"
            title="No Spend Trend"
            image="/Images/nospend.webp"
            seoTitle="Free English Lesson Plans: The No-Spend Trend"
            seoDescription="Financial English for budgeting, saving, and no-spend challenges. B2 level exercises including grammar, vocabulary, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Nospend;


  


